var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showButton)?_c('v-btn',{attrs:{"color":_vm.$vuetify.theme.dark ? 'grey darken-4' : 'primary',"fab":"","large":"","fixed":"","bottom":"","right":""},on:{"click":_vm.goOnTop}},[_c('v-icon',[_vm._v("fal fa-arrow-to-top")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }